export interface LineOptionProduct {
  id: number;
  name: string;
  defaultCode?: string;
  companyId: number | null;
  unitPrice?: number;
  costPrice?: number;
  defaultUnitOfMeasureId?: number;
  suggestedUnitOfMeasureIds?: number[];
  defaultTaxIds?: number[];
  saleOk?: boolean;
  purchaseOk?: boolean;
  description?: string;
}

export interface LineOptionUnitOfMeasure {
  id: number;
  name: string;
  factor: number;
  unitOfMeasureCategoryId: number;
}

export interface LineOptionTax {
  id: number;
  name: string;
  amount: number;
  companyId: number;
  taxType: string;
  amountType: string;
  invoiceTag?: string;
}

export interface SaleOrderLineOptions {
  saleOrderId: number;
  companyId: number;
  products: LineOptionProduct[];
  unitsOfMeasure: LineOptionUnitOfMeasure[];
  taxes: LineOptionTax[];
}

